import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  main: {
    marginLeft: 20,
    color: '#404040',
    fontSize: '1.8rem',
    fontWeight: 600
  },
  pipe: {
    background: '#84A086',
    width: 6,
    height: 28,
    marginBottom: -23
  },
  customMargin: {
    marginTop: '12vh',
    marginBottom: '2vh'
  }
}))

const SectionTitle = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.customMargin}>
      <div className={classes.pipe}></div>
      <Typography className={classes.main}>{props.title}</Typography>
    </div>
  )
}


export default SectionTitle;